import { Component, ViewEncapsulation, inject, DestroyRef } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LoadingBarOnPushComponent } from '../../../../../../shared/src/lib/feature-fuse/loading-bar-onpush/loading-bar-onpush.component';

@Component({
    selector: 'empty-layout',
    templateUrl: './empty.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [LoadingBarOnPushComponent, RouterOutlet],
})
export class EmptyLayoutComponent {
    private destroyRef = inject(DestroyRef);

    /**
     * Constructor
     */
    constructor() {
    }
}
